export const SELECT = {
  VALUES: {
    CRITICALITY: 'CRITICALITY',
    NAMES: 'NAMES',
  },
}
